import getCustomer from "./getCustomer";
import createCustomer from "./createCustomer";
import updateCustomer from "./updateCustomer";
import deleteCustomer from "./deleteCustomer";

export { getCustomer, createCustomer, updateCustomer, deleteCustomer };

export default { getCustomer, createCustomer, updateCustomer, deleteCustomer };
